import { Filter9Plus, Gavel, Person, ThumbsUpDown } from "@mui/icons-material";
import { action, computed, makeObservable, observable, reaction, runInAction } from "mobx";
import IconeDespacho from "../img/icones/IconeDespacho";
import IconeSemMinuta from "../img/icones/IconeSemMinuta";
import IconeVoto from "../img/icones/IconeVoto";
import { CategoriaMinuta, Filtro, FiltroRapido, IEtiqueta, IUsuario, Minuta, OrigemProcesso, Pauta, Processo, TAG_ALGUMA_ETIQUETA, TAG_NENHUMA_ETIQUETA, TipoMinuta } from "../modelo";
import { IAutocomplete } from "../modelo/Autocomplete";
import { IFiltroRapido } from "../modelo/FiltroRapido";
import { HistoricoMinutaDto } from "../modelo/HistoricoMinuta";
import { SituacaoMinuta } from "../modelo/SituacaoMinuta";
import { FiltroTriagem } from "../modelo/Triagem";
import { UnidadePublicadora } from "../modelo/UnidadePublicadora";
import FiltroService from "../services/FiltroService";
import InformacoesProcessoService from "../services/InformacoesProcessoService";
import UtilNumeroProcesso from "../utils/UtilNumeroProcesso";
import BaseFiltroStore from "./BaseFiltroStore";
import ControleGabineteStore from "./ControleGabineteStore";
import EscaninhoStore from "./EscaninhoStore";
import FiltroAutoCompleteStore from "./FiltroAutoCompleteStore";
import GabineteStore from "./GabineteStore";

import ProcessoService from "@/services/ProcessoService";
import MensagemStore from "./MensagemStore";
import PaginacaoStore from "./PaginacaoStore";
import PautaRevisaoStore from "./PautaRevisaoStore";
import ProcessoExpandidoStore from "./ProcessoExpandidoStore";
import ProcessoStore from "./ProcessoStore";
import RouterStore from "./RouterStore";
import StatusRevisaoPautaStore from "./StatusRevisaoPautaStore";
import UsuarioStore from './UsuarioStore';


const FILTRO_SEM_REVISOR = '__SEM_REVISOR__';

class FiltroStore extends BaseFiltroStore {
    drawerIsOpen: boolean = false;
    carregandoAplicacaoFiltro: boolean = false;
    preparandoEscaninho: boolean = false;
    carregandoEntradaEscaninho: boolean = false;
    private versaoAplicacaoFiltro = 0;
    processosPreparados: Processo[] | undefined = undefined;

    private contextosFiltrosSalvosCarregados = new Set<string>();
    private carregouListasBase = false;

    filtrosEscaninho: IFiltroRapido[] = [];
    nomeFiltroEscaninho: string = '';
    modalSalvarFiltroAberto: boolean = false;
    modalUsarFiltroAberto: boolean = false;
    idFiltroUsado: number;
    idFiltroEdicao: number;
    filtrosAtivosAplicados: Filtro[] = [];
    abrirAgrupadores: boolean = false;
    filtroTipoMinuta = [];
    dataInicioMinutaAssinadaFiltro;
    dataFimMinutaAssinadaFiltro;
    filtroAplicadoMinutasAssinadasDados: any = undefined;
    historicoMinuta: HistoricoMinutaDto[] = [];
    partesProcessos;

    /** Listas de opções de autocomplete dos filtros (classe, tema, pauta, movimento...). */
    get unidadesDePublicacao(): UnidadePublicadora[] {
        return FiltroAutoCompleteStore.unidadesDePublicacao;
    }
    // @observable processosMantidosNoFiltro = new Map<number, boolean>();

    constructor() {
        super();

        makeObservable(this, {
            drawerIsOpen: observable,
            carregandoAplicacaoFiltro: observable,
            preparandoEscaninho: observable,
            processosPreparados: observable.shallow,
            carregandoEntradaEscaninho: observable,
            filtrosEscaninho: observable,
            nomeFiltroEscaninho: observable,
            modalSalvarFiltroAberto: observable,
            modalUsarFiltroAberto: observable,
            idFiltroUsado: observable,
            idFiltroEdicao: observable,
            filtrosAtivosAplicados: observable,
            abrirAgrupadores: observable,
            filtroTipoMinuta: observable,
            dataInicioMinutaAssinadaFiltro: observable,
            dataFimMinutaAssinadaFiltro: observable,
            filtroAplicadoMinutasAssinadasDados: observable,
            historicoMinuta: observable,
            partesProcessos: observable,
            limparFiltros: action,
            cancelarAplicacaoFiltro: action,
            limparFiltrosMinutasAssinadas: action,
            limparFiltroControleUrl: action,
            limparFiltroOjcUrl: action,
            limparFiltroUsuario: action,
            filtrosAtivos: computed,
            aplicarFiltros: action
        });

        reaction(
            () => this.drawerIsOpen,
            (aberto) => {
                if (!aberto) {
                    return;
                }
                const contextoAtual = RouterStore.isMinutasAssinadas
                    ? 'minutasAssinadas'
                    : (RouterStore.isAlgumEscaninho ? 'escaninho' : '');

                if (!contextoAtual) {
                    return;
                }

                if (!this.contextosFiltrosSalvosCarregados.has(contextoAtual)) {
                    FiltroService.carregarFiltrosSalvos(true);
                    this.contextosFiltrosSalvosCarregados.add(contextoAtual);
                } else {
                    FiltroService.carregarFiltrosSalvos(false);
                }
            }
        );
        reaction(
            () => this.drawerIsOpen,
            (aberto) => {
                if (!aberto || this.carregouListasBase || !RouterStore.isAlgumEscaninho) {
                    return;
                }
                const precisaAssuntos = !ProcessoStore.carregouAssuntos && !ProcessoStore.carregandoAssuntos;
                const precisaIndicadores = !ProcessoStore.carregouIndicadores && !ProcessoStore.carregandoIndicadores;
                if (precisaAssuntos) {
                    ProcessoService.carregarAssuntosDeTodosOsProcessosAsync();
                }
                if (precisaIndicadores) {
                    ProcessoService.carregarIndicadoresDeTodosOsProcessosAsync();
                }
                if (precisaAssuntos || precisaIndicadores) {
                    this.carregouListasBase = true;
                }
            }
        );
    }


    cancelarAplicacaoFiltro = () => {
        this.versaoAplicacaoFiltro++;
        this.processosPreparados = undefined;
        this.carregandoAplicacaoFiltro = false;
    };

    limparFiltros = () => {
        this.cancelarAplicacaoFiltro();
        this.nomeFiltroEscaninho = '';
        this.idFiltroUsado = undefined;
        this.limparFiltrosBase();
    };

    limparFiltrosMinutasAssinadas = () => {
        this.nomeFiltroEscaninho = '';
        this.idFiltroUsado = undefined;
        this.idFiltroEdicao = undefined;
        this.filtroAplicadoMinutasAssinadasDados = undefined;

        this.dataInicioMinutaAssinadaFiltro = '';
        this.dataFimMinutaAssinadaFiltro = '';
        this.filtroTipoMinuta = [];

        this.numeroProcessoFilter = '';
        this.digitoProcessoFilter = '';
        this.anoProcessoFilter = '';
        this.orgaoProcessoFilter = '';
        this.regionalProcessoFilter = '';
        this.varaProcessoFilter = '';

        this.classeProcessoFilter = [];
        this.listaDeNumeroProcessoFilter = '';

        const inputDataInicio = window.document.getElementById('filtroDataInicio') as any;
        const inputDataFim = window.document.getElementById('filtroDataFim') as any;
        if (inputDataInicio) inputDataInicio.value = '';
        if (inputDataFim) inputDataFim.value = '';
    };

    // @action marcarMantido(processo: Processo, valor: boolean) {
    //     this.processosMantidosNoFiltro.set(processo.identificadorProcesso, valor);
    // }

    // getMantido(processo: Processo) {
    //     return this.processosMantidosNoFiltro.get(processo.identificadorProcesso) === true;
    // }

    // @action resetMantidos() {
    //     this.processosMantidosNoFiltro.clear();
    // }

    // As listas de opções de autocomplete (classe, tema, pauta, movimento, OJ, situação de
    // minuta, etiqueta, partes, assuntos...) vivem no FiltroAutoCompleteStore; os getters
    // abaixo são fachada para manter a API pública do FiltroStore inalterada.
    get classesUnicasFormatoAutoComplete() {
        return FiltroAutoCompleteStore.classesUnicasFormatoAutoComplete;
    }

    get temasUnicosFormatoAutoComplete(): IAutocomplete<string>[] {
        return FiltroAutoCompleteStore.temasUnicosFormatoAutoComplete;
    }

    get pautasUnicasFormatoAutoComplete(): IAutocomplete<Pauta>[] {
        return FiltroAutoCompleteStore.pautasUnicasFormatoAutoComplete;
    }

    get movimentos(): IAutocomplete<string>[] {
        return FiltroAutoCompleteStore.movimentos;
    }

    get resultadoJulgamento(): IAutocomplete<string>[] {
        return FiltroAutoCompleteStore.resultadoJulgamento;
    }

    get categoriasUnicasFormatoAutoComplete(): IAutocomplete<CategoriaMinuta>[] {
        return FiltroAutoCompleteStore.categoriasUnicasFormatoAutoComplete;
    }

    get cpfsUltimaAlteracaoSituacaoMinutaAutocomplete(): IAutocomplete<IUsuario>[] {
        return FiltroAutoCompleteStore.cpfsUltimaAlteracaoSituacaoMinutaAutocomplete;
    }

    get ojAutoComplete(): IAutocomplete<string>[] {
        return FiltroAutoCompleteStore.ojAutoComplete;
    }

    get situacaoMinutaFormatoAutoComplete(): IAutocomplete<string>[] {
        return FiltroAutoCompleteStore.situacaoMinutaFormatoAutoComplete;
    }

    get listaFiltros(): IAutocomplete<any>[] {
        try {
            const filtros = [
                'foraDoFluxo',
                RouterStore.isEscaninhoAssinatura && 'assinatura',
                'origem',
                'numeroProcesso',
                'listaProcesso',
                'ojc',
                'andamento',
                'movimentacao',
                'anoAutuacao',
                'etiqueta',
                'responsavel',
                'possuiResponsavel',
                'indicador',
                'classe',
                'assunto',
                'categoria',
                'inclusaoPauta',
                'movimento',
                'partes',
                'resultadoJulgamento',
                'situacaoMinuta',
                !RouterStore.isEscaninhoPeticao && 'peticao',
                'impedimento',
                'tipoJulgamento',
                'possuiMinuta',
                'unidadePublicadora',
                'publicavel',
                'estrela',
                'redator',
                'retornoGabinete',
                'triagemLivre',
                RouterStore.isEscaninhoJulgamento && 'votoLiberado',
                'correJuntoAssociado'
            ];

            if (RouterStore.isEscaninhoPeticao) {
                filtros.push('tiposPeticoesPendentes');
            }

            return filtros.filter((campo): campo is string => typeof campo === 'string').map(campo => {
                return {
                    texto: campo,
                    parametrosBusca: [campo, campo],
                    valor: campo
                };
            });
        } catch (err) {
            console.error("Erro no filtro: ", err);
            return [];
        }
    }

    get unidadePublicadoraFormatoAutoComplete(): IAutocomplete<string>[] {
        return FiltroAutoCompleteStore.unidadePublicadoraFormatoAutoComplete;
    }

    get etiquetasUnicasParaAutoComplete(): IAutocomplete<IEtiqueta>[] {
        return FiltroAutoCompleteStore.etiquetasUnicasParaAutoComplete;
    }

    get tiposPeticaoPendenteAutocomplete(): IAutocomplete<string>[] {
        return FiltroAutoCompleteStore.tiposPeticaoPendenteAutocomplete;
    }

    get partesUnicosFormatoAutoComplete() {
        return FiltroAutoCompleteStore.partesUnicosFormatoAutoComplete;
    }

    get impedimentosAutocomplete(): IAutocomplete<string>[] {
        return FiltroAutoCompleteStore.impedimentosAutocomplete;
    }

    get camposDeTriagemBooleanFormatoAutoComplete(): IAutocomplete<FiltroTriagem>[] {
        return FiltroAutoCompleteStore.camposDeTriagemBooleanFormatoAutoComplete;
    }

    get tiposMinutaAssinada(): IAutocomplete<any>[] {
        return FiltroAutoCompleteStore.tiposMinutaAssinada;
    }

    get camposDeResponsavelPelaTriagemAutoComplete(): IAutocomplete<IUsuario>[] {
        return FiltroAutoCompleteStore.camposDeResponsavelPelaTriagemAutoComplete;
    }

    get assuntosUnicosFormatoAutoComplete(): IAutocomplete<string>[] {
        return FiltroAutoCompleteStore.assuntosUnicosFormatoAutoComplete;
    }

    getValoresSelecionados = (valoresSelecionados, listaDeValores, parametroDeComparacao, parametroDeRetorno) => {
        const retorno = valoresSelecionados?.slice().splice(0, 2).map(valor => {
            const objetoEncontrado = listaDeValores.find(aux => {
                return aux[parametroDeComparacao] === valor;
            });
            return objetoEncontrado && objetoEncontrado[parametroDeRetorno];
        });
        return retorno.join(', ') + (valoresSelecionados.length > 2 ? '(+ ' + valoresSelecionados.length + ')' : '');
    }

    get filtrosRapidos() {
        const filtros = [];
        filtros.push(new FiltroRapido('possuiResponsavel_naoPossuiResponsavel_SP', 'Possui/Não Possui Responsável', this.possuiResponsavel || this.naoPossuiResponsavel,
            <Person />, runInAction.bind(this, () => { if (this.possuiResponsavel) { this.possuiResponsavel = false; this.naoPossuiResponsavel = true } else { this.naoPossuiResponsavel = false; this.possuiResponsavel = true } this.procurar(false) })
        ));
        filtros.push(new FiltroRapido('tipoMinutaDespacho_SP', 'Possui Despacho', this.possuiMinutaDespacho,
            <IconeDespacho color={this.possuiMinutaDespacho ? 'white' : undefined} />, runInAction.bind(this, () => { this.possuiMinutaDespacho = !this.possuiMinutaDespacho; this.naoPossuiMinuta = false; this.procurar(false) })
        ));
        filtros.push(new FiltroRapido('tipoMinutaDecisao_SP', 'Possui Decisao', this.possuiMinutaDecisao,
            <Gavel />, runInAction.bind(this, () => { this.possuiMinutaDecisao = !this.possuiMinutaDecisao; this.naoPossuiMinuta = false; this.procurar(false) })
        ));
        filtros.push(new FiltroRapido('tipoMinutaVoto_SP', 'Possui Voto', this.possuiMinutaVoto,
            <IconeVoto color={this.possuiMinutaVoto ? 'white' : undefined} />, runInAction.bind(this, () => { this.possuiMinutaVoto = !this.possuiMinutaVoto; this.naoPossuiMinuta = false; this.procurar(false) })
        ));
        filtros.push(new FiltroRapido('tipoMinutaVotoAgravoProvido_SP', 'Possui Voto Agravo Provido', this.possuiMinutaVotoAgravoProvido,
            <IconeVoto color={this.possuiMinutaVotoAgravoProvido ? 'white' : undefined} />, runInAction.bind(this, () => { this.possuiMinutaVotoAgravoProvido = !this.possuiMinutaVotoAgravoProvido; this.naoPossuiMinuta = false; this.procurar(false) })
        ));
        filtros.push(new FiltroRapido('semMinuta_SP', 'Não Possui Minutas', this.naoPossuiMinuta,
            <IconeSemMinuta color={this.naoPossuiMinuta ? 'white' : undefined} />, runInAction.bind(this, () => { this.naoPossuiMinuta = !this.naoPossuiMinuta; this.possuiMinutaVoto = false; this.possuiMinutaDespacho = false; this.possuiMinutaDecisao = false; this.procurar(false) })
        ));
        filtros.push(new FiltroRapido('peticaoPendente', 'Possui Qualquer Tipo de Petição Pendente', this.possuiPeticaoPendente,
            <Filter9Plus />, runInAction.bind(this, () => { this.possuiPeticaoPendente = !this.possuiPeticaoPendente; this.tipoPeticaoSelecionadaFilter = ['Qualquer tipo']; this.procurar(false) })
        ));
        filtros.push(new FiltroRapido('julgado_naoJulgado', 'Julgado / Não Julgado', this.julgadoFilter || this.naoJulgadoFilter,
            <ThumbsUpDown />, runInAction.bind(this, () => { if (this.julgadoFilter) { this.julgadoFilter = false; this.naoJulgadoFilter = true } else { this.naoJulgadoFilter = false; this.julgadoFilter = true } this.procurar(false) })
        ));

        return filtros;
    }

    get parametroControleUrl() {
        return new URLSearchParams(RouterStore.location?.search || '').get('controleNumero');
    }

    get parametroOjcUrl() {
        return new URLSearchParams(RouterStore.location?.search || '').get('OJC');
    }

    removerParametroUrlEReaplicarFiltro = (parametro: string) => {
        RouterStore.removerParametroQuery(parametro);

        setTimeout(() => {
            this.procurar(false);
        }, 0);
    };

    limparFiltroControleUrl = () => {
        this.removerParametroUrlEReaplicarFiltro('controleNumero');
    };

    limparFiltroOjcUrl = () => {
        this.removerParametroUrlEReaplicarFiltro('OJC');
    };

    limparFiltroUsuario = () => {
        this.usuarioSelecionadoFilter = [];

        if (RouterStore.isEscaninhoGerencial || RouterStore.isEscaninhoFiltrado) {
            this.removerParametroUrlEReaplicarFiltro('responsavel');
        }
    };

    get filtrosAtivos(): Filtro[] {
        const filtroAtivo = [];
        const numeroControleUrl = Number(this.parametroControleUrl);
        const controleUrl = Number.isFinite(numeroControleUrl)
            ? ControleGabineteStore.buscarPorNumero(numeroControleUrl)
            : undefined;
        const ojcUrl = this.parametroOjcUrl;

        filtroAtivo.push(new Filtro(
            'controleNumeroUrl',
            'Controle',
            !!this.parametroControleUrl,
            controleUrl?.descricao || this.parametroControleUrl || '',
            this.limparFiltroControleUrl
        ));

        filtroAtivo.push(new Filtro('possuiResponsavel_naoPossuiResponsavel', 'Possui Responsável',
            this.possuiResponsavel || this.naoPossuiResponsavel, this.possuiResponsavel ? 'Sim' : 'Não',
            runInAction.bind(this, () => {
                this.possuiResponsavel = false;
                this.naoPossuiResponsavel = false;
                this.procurar()

            }),
            true, (this.possuiResponsavel ? true : false) // TODO: icone
        ));

        filtroAtivo.push(new Filtro('incluirforadofluxo', 'Fora do fluxo do GE',
            this.foraDoGabineteFilter, 'Sim',
            runInAction.bind(this, () => { this.foraDoGabineteFilter = false }),
        ));
        filtroAtivo.push(new Filtro('possuiredator', 'Possui redator designado',
            this.possuiRedatorDesignado, this.possuiRedatorDesignado ? 'Sim' : 'Não',
            runInAction.bind(this, () => { this.possuiRedatorDesignado = false }),
        ));

        const underlineInicial = this.numeroProcessoFilter.length === 7 ? '' : '_';
        const underlineFimNum = this.numeroProcessoFilter.length === 7 ? '' : '_';
        const underlineIniDigito = this.digitoProcessoFilter.length === 2 ? '' : '_';
        const underlineFimDigito = this.digitoProcessoFilter.length === 2 ? '' : '_';
        const underlineIniAno = this.anoProcessoFilter.length === 4 ? '' : '_';
        const underlineFimAno = this.anoProcessoFilter.length === 4 ? '' : '_';
        const underlineIniOrgao = this.orgaoProcessoFilter.length === 1 ? '' : '_';
        const underlineFimOrgao = this.orgaoProcessoFilter.length === 1 ? '' : '_';
        const underlineIniRegional = this.regionalProcessoFilter.length === 2 ? '' : '_';
        const underlineFimRegional = this.regionalProcessoFilter.length === 2 ? '' : '_';
        const underlineIniVara = this.varaProcessoFilter.length === 4 ? '' : '_';
        const underlineFimVara = this.varaProcessoFilter.length === 4 ? '' : '_';
        filtroAtivo.push(new Filtro('numProcesso', 'Número Processo', this.numeroProcessoInformado,
            `${underlineInicial}${this.numeroProcessoFilter}${underlineFimNum}-
         ${underlineIniDigito}${this.digitoProcessoFilter}${underlineFimDigito}.
         ${underlineIniAno}${this.anoProcessoFilter}${underlineFimAno}.
         ${underlineIniOrgao}${this.orgaoProcessoFilter}${underlineFimOrgao}.
         ${underlineIniRegional}${this.regionalProcessoFilter}${underlineFimRegional}.
         ${underlineIniVara}${this.varaProcessoFilter}${underlineFimVara}`,
            this.limparNumero
        ));

        const tipos = [];
        this.possuiMinutaDespacho && tipos.push('Despacho');
        this.possuiMinutaDecisao && tipos.push('Decisao');
        this.possuiMinutaVoto && tipos.push('Voto');
        this.possuiMinutaVotoAgravoProvido && tipos.push('Voto com RR');
        filtroAtivo.push(new Filtro('tipoMinuta', 'Tipo de Minuta',
            tipos.length > 0,
            tipos.join(', '),
            this.limparTiposMinuta
        ));

        filtroAtivo.push(new Filtro('naoPossuiMinuta', 'Tipo de Minuta', this.naoPossuiMinuta,
            'Sem Minuta', runInAction.bind(this, () => { this.naoPossuiMinuta = false })
        ));

        filtroAtivo.push(new Filtro('textoTriagem', 'Triagem Livre', this.textoTriagemFilter?.length > 2,
            this.textoTriagemFilter, runInAction.bind(this, () => this.textoTriagemFilter = '')
        ));

        filtroAtivo.push(new Filtro('anoAutuacao', 'Ano de Autuação no TST', this.anoAutuacaoFilter?.length > 0,
            this.anoAutuacaoFilter?.map(e => e).join(', '),
            runInAction.bind(this, () => this.anoAutuacaoFilter = [])
        ));

        filtroAtivo.push(new Filtro('processoRetornandoAoGabinete', 'Processo retornando ao Gabinete', this.processoRetornandoAoGabinete,
            'sim',
            runInAction.bind(this, () => this.processoRetornandoAoGabinete = false)
        ));

        filtroAtivo.push(new Filtro('listaDeProcessos', 'Lista de Processos', this.listaDeNumeroProcessoFilter?.length > 0,
            (this.numerosNoFiltro.length > 3 ? this.numerosNoFiltro.length + ' processos' : this.numerosNoFiltro.map(num => num).join('; '))
            , runInAction.bind(this, () => this.listaDeNumeroProcessoFilter = '')
        ));

        filtroAtivo.push(new Filtro('tipoJulgamentoPresencialFilter_tipoJulgamentoVirtualFilter', 'Processo',
            this.tipoJulgamentoPresencialFilter || this.tipoJulgamentoVirtualFilter, this.tipoJulgamentoPresencialFilter ? 'Julgamento Presencial' : 'Julgamento Virtual',
            runInAction.bind(this, () => { this.tipoJulgamentoPresencialFilter = false; this.tipoJulgamentoVirtualFilter = false })
        ));

        filtroAtivo.push(new Filtro('julgadoFilter_naoJulgadoFilter', 'Processo',
            this.julgadoFilter || this.naoJulgadoFilter, this.julgadoFilter ? 'Julgado' : 'Não julgado',
            runInAction.bind(this, () => { this.julgadoFilter = false; this.naoJulgadoFilter = false })
        ));

        filtroAtivo.push(new Filtro('publicavelFilter_naoPublicavelFilter', 'Minuta',
            this.publicavelFilter || this.naoPublicavelFilter, this.publicavelFilter ? 'Publicável' : 'Não Publicável',
            runInAction.bind(this, () => { this.publicavelFilter = false; this.naoPublicavelFilter = false })
        ));

        filtroAtivo.push(new Filtro('votoLiberadoFilter_votoNaoLiberadoFilter', 'Minuta',
            this.votoLiberadoFilter || this.votoNaoLiberadoFilter, this.votoLiberadoFilter ? 'Voto Liberado' : 'Voto não Liberado',
            runInAction.bind(this, () => { this.votoLiberadoFilter = false; this.votoNaoLiberadoFilter = false })
        ));

        filtroAtivo.push(new Filtro('correJuntoFilter_associadoFilter', 'Processo',
            this.correJuntoFilter || this.associadoFilter, this.correJuntoFilter ? 'Com Corre Junto' : 'Com Processo Associado',
            runInAction.bind(this, () => { this.correJuntoFilter = false; this.associadoFilter = false })
        ))

        filtroAtivo.push(new Filtro('favoritoFilter_naoFavoritoFilter', 'Processo',
            this.favoritoFilter || this.naoFavoritoFilter, this.favoritoFilter ? 'Com estrela' : 'Sem estrela',
            runInAction.bind(this, () => { this.favoritoFilter = false; this.naoFavoritoFilter = false })
        ));

        filtroAtivo.push(new Filtro('orgaoJudicanteSelecionadoFilter', 'OJ', this.orgaoJudicanteSelecionadoFilter?.length > 0,
            this.orgaoJudicanteSelecionadoFilter?.slice(0, 2).join(', ')
            + (this.orgaoJudicanteSelecionadoFilter.length > 2 ?
                ' (+' + (this.orgaoJudicanteSelecionadoFilter.length - 2).toString() + ')'
                :
                ''
            ),
            runInAction.bind(this, () => this.orgaoJudicanteSelecionadoFilter = [])
        ));

        filtroAtivo.push(new Filtro('andTramTarefasSelecionadoFilter', 'Andamento/Tramitação/Tarefas/Movimento CNJ', this.andTramTarefasSelecionadoFilter?.length > 0,
            this.andTramTarefasSelecionadoFilter?.slice(0, 2).join(', ')
            + (this.andTramTarefasSelecionadoFilter?.length > 2 ?
                ' (+' + (this.andTramTarefasSelecionadoFilter?.length - 2).toString() + ')'
                :
                ''
            ),
            runInAction.bind(this, () => this.andTramTarefasSelecionadoFilter = [])
        ));


        filtroAtivo.push(new Filtro('possuiPeticaoPendente', 'Petição Pendente', this.possuiPeticaoPendente,
            this.tipoPeticaoSelecionadaFilter.join(', '),
            this.limparPossuiPeticaoPendenteETiposPeticao
        ));

        filtroAtivo.push(new Filtro('naoPossuiPeticaoPendente', 'Petição Pendente', this.naoPossuiPeticaoPendente,
            'Não possui',
            this.limparNaoPossuiPeticaoPendente
        ));

        filtroAtivo.push(new Filtro('possuiImpedimento', 'Impedimento/Suspeição', this.possuiImpedimento,
            this.motivoImpedimentoSelecionadoFilter?.map(mot => mot.substring(0, mot.length > 10 ? 10 : mot.length) + (mot.length > 10 ? '...' : '')).join(', '),
            this.limparPossuiImpedimentoETiposImpedimento
        ));

        filtroAtivo.push(new Filtro('MovimentaçãoSelecionadaFilter', 'Movimentação', this.tarefaSelecionadaFilter?.length > 0,
            this.getValoresSelecionados(this.tarefaSelecionadaFilter, ControleGabineteStore.listaDeControles,
                'descricao', 'descricao'),
            runInAction.bind(this, () => this.tarefaSelecionadaFilter = [])
        ));

        filtroAtivo.push(new Filtro('usuarioSelecionadoFilter', 'Responsável', this.usuarioSelecionadoFilter?.length > 0,
            // listaUsuariosGabinete só cobre os servidores do gabinete atual; usuarios de
            // outros gabinetes/OJCs (ex.: vindos do controle de gabinete) caem no cache
            // de nomes do GabineteStore, que resolve por CPF independente do gabinete.
            this.usuarioSelecionadoFilter.map(login => GabineteStore.recuperarNomeServidor(login)).filter(Boolean).join(', '),
            this.limparFiltroUsuario
        ));

        filtroAtivo.push(new Filtro(
            'ojcUrl',
            'OJC',
            !!ojcUrl,
            ojcUrl
                ?.split(',')
                .map(valor => valor === 'SEM_OJC' ? 'Sem OJC cadastrado' : valor)
                .join(', ') || '',
            this.limparFiltroOjcUrl
        ));

        filtroAtivo.push(new Filtro('revisorPautaFilter', 'Revisor', this.revisorPautaFilter?.length > 0,
            this.revisorPautaFilter
                .map((revisor) => {
                    if (revisor === FILTRO_SEM_REVISOR) {
                        return 'Sem Revisor';
                    }
                    return this.usuariosAutoComplete.find(usuario => usuario.valor === revisor)?.texto || revisor;
                })
                .join(', ') || this.revisorPautaFilter?.join(', '),
            runInAction.bind(this, () => this.revisorPautaFilter = [])
        ));

        filtroAtivo.push(new Filtro('statusRevisaoFilter', 'Status da Revisão', this.statusRevisaoFilter?.length > 0,
            StatusRevisaoPautaStore.lista
                .filter(status => this.statusRevisaoFilter.map(Number).includes(status.codigo))
                .map(status => status.descricao)
                .join(', ') || this.statusRevisaoFilter?.join(', '),
            runInAction.bind(this, () => this.statusRevisaoFilter = [])
        ));

        filtroAtivo.push(new Filtro('etiquetaSelecionadaFilter', 'Etiqueta', this.etiquetaSelecionadaFilter?.length > 0,
            this.etiquetaSelecionadaFilter.map(e => e.texto).join(', '),
            runInAction.bind(this, () => this.etiquetaSelecionadaFilter = [])
        ));

        filtroAtivo.push(new Filtro('indicadorSelecionadoFilter', 'Indicadores / Chips', this.indicadorSelecionadoFilter?.length > 0,
            this.indicadoresAutoComplete.filter(indicador => this.indicadorSelecionadoFilter.includes(indicador.texto)).map(indicador => indicador.texto).join(', '),
            runInAction.bind(this, () => this.indicadorSelecionadoFilter = [])
        ));

        filtroAtivo.push(new Filtro('situacaoMinutaFilter', 'Situação Minuta', this.situacaoMinutaFilter?.length > 0,
            this.situacaoMinutaFilter?.map((situacao) => situacao).join(', '),
            runInAction.bind(this, () => this.situacaoMinutaFilter = [])
        ));

        filtroAtivo.push(new Filtro('unidadePublicadoraFilter', 'Unidade Publicadora', this.unidadePublicadoraFilter?.length > 0,
            this.unidadePublicadoraFilter?.map((unidade) => unidade).join(', '),
            runInAction.bind(this, () => this.unidadePublicadoraFilter = [])
        ));

        filtroAtivo.push(new Filtro('categoriaProcessoFilter', 'Categoria', this.categoriaProcessoFilter?.length > 0,
            this.categoriaProcessoFilter.map((categoria) => categoria.descricao).join(', '),
            runInAction.bind(this, () => this.categoriaProcessoFilter = [])
        ));

        filtroAtivo.push(new Filtro('assuntoFilter', 'Assunto', this.assuntoFilter?.length > 0,
            this.assuntoFilter.join(', '),
            runInAction.bind(this, () => this.assuntoFilter = [])
        ));

        filtroAtivo.push(new Filtro('parteFilter', 'Parte', this.parteFilter !== '',
            this.parteFilter,
            runInAction.bind(this, () => this.parteFilter = '')
        ));

        filtroAtivo.push(new Filtro('classeProcessoFilter', 'Fase Atual', this.classeProcessoFilter?.length > 0,
            this.classeProcessoFilter?.join(', '),
            runInAction.bind(this, () => this.classeProcessoFilter = [])
        ));

        filtroAtivo.push(new Filtro('classeInicialProcessoFilter', 'Classe Inicial', this.classeInicialProcessoFilter?.length > 0,
            this.classeInicialProcessoFilter?.join(', '),
            runInAction.bind(this, () => this.classeInicialProcessoFilter = [])
        ));
        filtroAtivo.push(new Filtro('classeInteiraFilter', 'Classe', this.classeInteiraFilter?.length > 0,
            this.classeInteiraFilter?.join(', '),
            runInAction.bind(this, () => this.classeInteiraFilter = [])
        ));


        filtroAtivo.push(new Filtro('assinavel', 'Minutas Assináveis do tipo', this.assinavel,
            `${this.tipoMinutaFilter.length === 0 ? 'Qualquer tipo' : this.tipoMinutaFilter.join(', ')}`,
            runInAction.bind(this, () => { this.assinavel = false; this.tipoMinutaFilter = []; })
        ));

        filtroAtivo.push(new Filtro('pauta', 'Pauta', this.pautaFilter?.length > 0,
            this.pautaFilter?.join(', '),
            runInAction.bind(this, () => this.pautaFilter = [])
        ))

        filtroAtivo.push(new Filtro('origem', 'Origem do processo', this.origem?.includes('L') || this.origem?.includes('P'),
            (this.origem?.includes('L') ? 'eSIJ' : '') + (this.origem?.length > 1 ? ' / ' : '') + (this.origem?.includes('P') ? 'PJe' : ''), runInAction.bind(this, () => this.origem = '' as OrigemProcesso)
        ));

        filtroAtivo.push(new Filtro('movimentosFilter', 'Movimento', this.movimentosFilter?.length > 0,
            this.movimentosFilter?.join(', '),
            runInAction.bind(this, () => this.movimentosFilter = [])
        ));

        filtroAtivo.push(new Filtro('resultadoJulgamentoFilter', 'Resultado Julgamento', this.resultadoJulgamentoFilter?.length > 0,
            this.resultadoJulgamentoFilter?.join(', '),
            runInAction.bind(this, () => this.resultadoJulgamentoFilter = [])
        ));

        filtroAtivo.push(new Filtro('situacaoPeticaoFilter', 'Situacao da peticao', this.situacaoPeticaoFilter?.length > 0,
            this.situacaoPeticaoFilter,
            runInAction.bind(this, () => this.situacaoPeticaoFilter = '')
        ));

        filtroAtivo.push(new Filtro('tipoPeticaoSelecionadaFilter', 'Tipo da peticao', !this.possuiPeticaoPendente
            && this.tipoPeticaoSelecionadaFilter?.length > 0
            && this.tipoPeticaoSelecionadaFilter?.[0] !== 'Qualquer tipo',
            this.tipoPeticaoSelecionadaFilter?.join(', '),
            runInAction.bind(this, () => this.tipoPeticaoSelecionadaFilter = [])
        ));

        filtroAtivo.push(new Filtro('dataPeticaoFilter', 'Data da petição', this.possuiIntervaloDataPeticao,
            this.descricaoIntervaloDataPeticao,
            runInAction.bind(this, () => {
                this.dataInicioPeticaoFilter = '';
                this.dataFimPeticaoFilter = '';
            })
        ));

        filtroAtivo.push(new Filtro('camposDeTriagemBooleanFilter', 'Campos de triagem', this.camposDeTriagemBooleanFilter?.length > 0,
            this.camposDeTriagemBooleanFilter?.map(campo => campo.descricao).join(', '),
            runInAction.bind(this, () => this.camposDeTriagemBooleanFilter = [])
        ));

        filtroAtivo.push(new Filtro('camposDeResponsavelPelaTriagemFilter', 'Campos de triagem', this.camposDeResponsavelPelaTriagemFilter?.length > 0,
            this.camposDeResponsavelPelaTriagemFilter?.map(usuario => usuario.nome).join(', '),
            runInAction.bind(this, () => this.camposDeResponsavelPelaTriagemFilter = [])
        ));

        filtroAtivo.push(new Filtro('camposDeTriagemValorCondenacaoFilter', 'Valor de condenação', this.camposDeTriagemValorCondenacaoFilter?.length > 0,
            this.formatarValorCondenacaoChip(this.camposDeTriagemValorCondenacaoFilter),
            runInAction.bind(this, () => this.camposDeTriagemValorCondenacaoFilter = '')
        ));
        filtroAtivo.push(new Filtro('temaProcessoFilter', 'Temas', this.temaProcessoFilter?.length > 0,
            this.temaProcessoFilter?.join(', '),
            runInAction.bind(this, () => this.temaProcessoFilter = [])
        ));
        filtroAtivo.push(new Filtro('usuarioModificadorSituacaoMinutaFilter', 'Último a modificar', this.usuariosUltimaAlteracaoSituacaoMinutaFilter?.length > 0,
            this.usuariosUltimaAlteracaoSituacaoMinutaFilter?.map(usuario => usuario.nome).join(', '),
            runInAction.bind(this, () => this.usuariosUltimaAlteracaoSituacaoMinutaFilter = [])
        ));
        filtroAtivo.push(new Filtro('relatorProcessoFilter', 'Relator', this.relatorProcessoFilter?.length > 0, this.relatorProcessoFilter?.join(', '),
            runInAction.bind(this, () => this.relatorProcessoFilter = [])
        ))

        return filtroAtivo;
    }

    private async processarProcessosEmBlocos(
        processos: Processo[], versao: number, processar: (processo: Processo) => void,
        publicar?: (processo: Processo) => boolean
    ): Promise<void> {
        const tempoMaximoBlocoMs = 8;
        let indice = 0;
        while (indice < processos.length) {
            if (versao !== this.versaoAplicacaoFiltro) return;
            const inicioBloco = performance.now();
            let primeiraPaginaPronta = false;
            runInAction(() => {
                do {
                    const processo = processos[indice++];
                    processar(processo);
                    // A primeira página deve poder pintar antes de preparar o próximo bloco.
                    if (publicar?.(processo)) {
                        primeiraPaginaPronta = true;
                        break;
                    }
                } while (indice < processos.length
                    && performance.now() - inicioBloco < tempoMaximoBlocoMs);
            });
            if (indice < processos.length) {
                if (primeiraPaginaPronta) {
                    await this.aguardarPinturaFiltro();
                } else {
                    await new Promise<void>(resolve => setTimeout(resolve, 0));
                }
            }
        }
    }

    private aguardarPinturaFiltro = () => new Promise<void>(resolve => {
        requestAnimationFrame(() => requestAnimationFrame(() => resolve()));
    });

    procurar = (mostrarMensagem: boolean = true, resetPagina: boolean = true, aguardarPintura: boolean = true) => {
        if (this.intervaloDataPeticaoInvalido) {
            MensagemStore.apresentarAviso('A data de início não pode ser posterior à data de fim.');
            return;
        }
        runInAction(() => {
            this.aplicarIntervaloDataPeticao();
        });
        if (this.possuiPeticaoPendente && (!this.tipoPeticaoSelecionadaFilter || this.tipoPeticaoSelecionadaFilter.length === 0)) {
            runInAction(() => {
                this.tipoPeticaoSelecionadaFilter = ['Qualquer tipo'];
            });
        }
        if (this.possuiImpedimento && (!this.motivoImpedimentoSelecionadoFilter || this.motivoImpedimentoSelecionadoFilter.length === 0)) {
            runInAction(() => {
                this.motivoImpedimentoSelecionadoFilter = ['Qualquer tipo'];
            });
        }
        if (RouterStore.isEscaninhoPeticao) {
            const carregandoPeticoes =
                ProcessoStore.carregandoPeticoesPendentes ||
                // ProcessoStore.carregandoQTDPeticoesPendentes ||
                // ProcessoStore.carregandoDocPeticoes ||
                ProcessoExpandidoStore.carregandoPecas;
            if (carregandoPeticoes) {
                return;
            }
        }
        // PL é a origem padrão (PJe e legado), sem restringir a lista.
        const origem = String(this.origem || '').toUpperCase();
        const origemSemRestricao = !origem || (origem.includes('P') && origem.includes('L'));
        const restaurarListaBase = RouterStore.isEscaninhoGerencial
            && !this.preparandoEscaninho
            && origemSemRestricao && this.nenhumParametroSelecionado(true);
        if (restaurarListaBase || !this.nenhumParametroSelecionado()) {
            const versaoAtual = ++this.versaoAplicacaoFiltro;
            runInAction(() => {
                this.processosPreparados = undefined;
                if (resetPagina) {
                    PaginacaoStore.paginaFiltro = 1;
                }
                this.filtroAplicado = true;
                this.carregandoAplicacaoFiltro = true;
                this.filtrosAtivosAplicados = this.filtrosAtivos.filter(filtro => filtro.apresentar);
            });
            (async () => {
                try {
                    if (!RouterStore.isEscaninhoPauta && aguardarPintura) {
                        await this.aguardarPinturaFiltro();
                    }
                    if (versaoAtual !== this.versaoAplicacaoFiltro) return;
                    const processos = EscaninhoStore.processosPorTipoEscaninho;

                    if (this.parteFilter.length > 0) {
                        const partesProcessos = await ProcessoService.buscarPartesProcessoFiltro();
                        if (versaoAtual !== this.versaoAplicacaoFiltro) return;
                        runInAction(() => {
                            this.partesProcessos = partesProcessos;
                        });
                    }

                    // Publica somente processos já avaliados, na ordem da consulta,
                    // inclusive quando há critérios de filtro no gabinete.
                    const progressivo = RouterStore.isEscaninhoGerencial;
                    const limitePrimeiraPagina = PaginacaoStore.ultimoIndice;
                    let primeiraPaginaLiberada = false;
                    if (progressivo) {
                        runInAction(() => { this.processosPreparados = []; });
                    }
                    await this.processarProcessosEmBlocos(processos, versaoAtual, processo => {
                        if (processo.selecionado) processo.selecionar(false);
                        if (restaurarListaBase) {
                            // Evita reescrever processos e minutas já visíveis ao voltar ao gabinete.
                            if (!processo.mostrar || processo.minutas.some(minuta => minuta && !minuta.mostrar)) {
                                processo.resetMostrar();
                            }
                            this.filtrarPorProcessosForaDoGabinete(processo);
                        } else {
                            processo.resetMostrar();
                            this.aplicarFiltros(processo);
                        }
                    }, progressivo ? processo => {
                        if (processo.mostrar) this.processosPreparados.push(processo);
                        if (!primeiraPaginaLiberada && this.processosPreparados.length >= limitePrimeiraPagina) {
                            primeiraPaginaLiberada = true;
                            this.carregandoAplicacaoFiltro = false;
                            this.carregandoEntradaEscaninho = false;
                            return true;
                        }
                        return false;
                    } : undefined);
                } finally {
                    if (versaoAtual === this.versaoAplicacaoFiltro) {
                        runInAction(() => {
                            this.processosPreparados = undefined;
                            this.filtroAplicado = true;
                            this.carregandoAplicacaoFiltro = false;
                            this.carregandoEntradaEscaninho = false;
                        });
                    }
                }
            })();

        } else {
            const versaoAtual = ++this.versaoAplicacaoFiltro;
            runInAction(() => {
                this.processosPreparados = undefined;
                this.filtroAplicado = false;
                this.carregandoAplicacaoFiltro = true;
                this.filtrosAtivosAplicados = [];
            });
            (async () => {
                try {
                    if (!RouterStore.isEscaninhoPauta && aguardarPintura) {
                        await this.aguardarPinturaFiltro();
                    }
                    if (versaoAtual !== this.versaoAplicacaoFiltro) return;
                    await this.processarProcessosEmBlocos(
                        EscaninhoStore.processosPorTipoEscaninho,
                        versaoAtual,
                        processo => processo.resetMostrar()
                    );
                    if (versaoAtual === this.versaoAplicacaoFiltro && mostrarMensagem) {
                        MensagemStore.apresentarInformacao('Não há parâmetros de pesquisa.');
                    }
                } finally {
                    if (versaoAtual === this.versaoAplicacaoFiltro) {
                        runInAction(() => {
                            this.carregandoAplicacaoFiltro = false;
                            this.carregandoEntradaEscaninho = false;
                        });
                    }
                }
            })();
        }
    }


    aplicarFiltros = (processo) => {
        let manterProcesso = false;
        if (RouterStore.isEscaninhoPeticao) {
            const carregandoPeticoes =
                ProcessoStore.carregandoPeticoesPendentes ||
                ProcessoStore.carregandoQTDPeticoesPendentes ||
                // ProcessoStore.carregandoDocPeticoes ||
                ProcessoExpandidoStore.carregandoPecas;
            if (carregandoPeticoes && processo.mostrar) {
                manterProcesso = true;
            }
        }
        if (RouterStore.isEscaninhoAssinatura) {
            this.filtrarPorAssinavelETipoDeMinuta(processo);
            if (!processo.mostrar) return;
        }


        for (const filtro of this.filtros) {
            filtro.call(this, processo);
            if (!processo.mostrar) return;
        }

        if (manterProcesso) {
            processo.setMostrar(true);
        }
        if (RouterStore.isEscaninhoAssinatura) {
            this.filtrarProcessosSecretaria(processo);
        }
    };


    filtrarProcessosSecretaria(processo: Processo) {
        if (UsuarioStore.ehSecretario || UsuarioStore.ehLocalizacaoSecretaria) {
            processo.minutas.forEach(minuta => minuta.setMostrar(
                minuta.mostrar && (
                    minuta.tipo.codigo === TipoMinuta.ATO_ORDINATORIO ||
                    minuta.tipo.codigo === TipoMinuta.DESPACHO ||
                    minuta.tipo.codigo === TipoMinuta.DECISAO
                )
            ));
            const algumaMostra = processo.minutas.some(m => !!m.mostrar);
            processo.setMostrar(algumaMostra);
        } else if (UsuarioStore.ehMagistrado) {
            processo.minutas.forEach(minuta => minuta.setMostrar(minuta.mostrar && minuta.tipo.codigo !== TipoMinuta.ATO_ORDINATORIO));
            const algumaMostra = processo.minutas.some(m => !!m.mostrar);
            processo.setMostrar(algumaMostra);
        }
    }

    filtrarNumeroProcesso = (processo: Processo) => {
        if (!this.numeroProcessoInformado) {
            return;
        }

        const n = UtilNumeroProcesso.matchObjetoNumeroProcesso(processo.numeroProcesso);

        const filtros = [
            [this.numeroProcessoFilter, n.numero],
            [this.digitoProcessoFilter, n.digito],
            [this.anoProcessoFilter, n.ano],
            [this.orgaoProcessoFilter, n.justica],
            [this.regionalProcessoFilter, n.tribunal],
            [this.varaProcessoFilter, n.vara],
        ];

        for (const [filtro, valor] of filtros) {
            if (filtro === this.numeroProcessoFilter) {
                if (!UtilNumeroProcesso.numeroEhCompativelComPrefixoZero(valor, filtro)) {
                    return processo.setMostrar(false);
                }
                continue;
            }
            if (!UtilNumeroProcesso.campoEhCompativelPorPrefixo(valor, filtro)) {
                return processo.setMostrar(false);
            }
        }

        processo.setMostrar(processo.mostrar && true);
    }

    filtrarPorListaDeNumeroProcesso = (processo: Processo) => {
        if (!this.listaDeNumeroProcessoFilter?.length) {
            return;
        }

        const numero = UtilNumeroProcesso.matchObjetoNumeroProcesso(processo.numeroProcesso);

        for (const numFiltro of this.numerosNoFiltro) {
            const f = UtilNumeroProcesso.matchObjetoNumeroProcesso(numFiltro);
            if (!f?.validoFormato) continue;
            if (f.numero && !UtilNumeroProcesso.numeroEhCompativelComPrefixoZero(numero.numero, f.numero)) continue;
            if (!UtilNumeroProcesso.campoEhCompativelPorPrefixo(numero.digito, f.digito)) continue;
            if (!UtilNumeroProcesso.campoEhCompativelPorPrefixo(numero.ano, f.ano)) continue;
            if (!UtilNumeroProcesso.campoEhCompativelPorPrefixo(numero.justica, f.justica)) continue;
            if (!UtilNumeroProcesso.campoEhCompativelPorPrefixo(numero.tribunal, f.tribunal)) continue;
            if (!UtilNumeroProcesso.campoEhCompativelPorPrefixo(numero.vara, f.vara)) continue;

            return processo.setMostrar(true);
        }

        processo.setMostrar(false);
    }


    filtrarPorTriagem = (processo: Processo) => {
        if (this.textoTriagemFilter?.length > 0) {
            const achou = processo.triagemLivre?.toLowerCase()?.includes(
                this.textoTriagemFilter.toLowerCase()
            );
            processo.setMostrar(processo.mostrar && !!achou);
        }
    }

    filtrarPorAnoAutuacao = (processo: Processo) => {
        if (!this.anoAutuacaoFilter.length) {
            return;
        }

        const anoAutuacao = processo.dataAutuacaoTst ?
            new Date(processo.dataAutuacaoTst).getFullYear().toString()
            :
            null;

        const achou = anoAutuacao && this.anoAutuacaoFilter.includes(anoAutuacao);

        processo.setMostrar(processo.mostrar && !!achou);
    }

    filtrarPorTema = (processo: Processo) => {
        if (this.temaProcessoFilter.length > 0) {
            processo.setMostrar(processo.mostrar && processo.temas.some(tema => this.temaProcessoFilter.some(temaFilter => temaFilter === tema.desTema)));
        }
    }

    filtrarPorCampoDeTriagemBoolean = (processo: Processo) => {
        if (this.camposDeTriagemBooleanFilter.length > 0) {
            processo.setMostrar(processo.mostrar && this.camposDeTriagemBooleanFilter.some(campo => {
                const existeCampoArray = processo.triagem?.camposTriagem.some(campoTriagem => campoTriagem.codCampoTriagem === parseInt(campo.valor));
                return processo.triagem && (processo.triagem[campo.valor] || existeCampoArray);
            }));
        }
    }

    filtrarPorCampoDeTriagemValorCondenacao = (processo: Processo) => {
        if (this.camposDeTriagemValorCondenacaoFilter.length > 0) {
            const filtro = this.camposDeTriagemValorCondenacaoFilter?.trim() || '';
            const valorCondenacao = processo.triagem?.valorCondenacao?.toString() || '';

            const achouPorTexto = valorCondenacao.toLowerCase().includes(filtro.toLowerCase());
            const filtroNumerico = filtro.replace(/\D+/g, '');
            const valorCondenacaoNumerico = valorCondenacao.replace(/\D+/g, '');
            const achouPorNumero = filtroNumerico.length > 0 && valorCondenacaoNumerico.includes(filtroNumerico);
            const filtroNumeroMonetario = this.normalizarNumeroMonetario(filtro);
            const valorNumeroMonetario = this.normalizarNumeroMonetario(valorCondenacao);
            const achouPorValorMonetario = filtroNumeroMonetario !== undefined
                && valorNumeroMonetario !== undefined
                && Math.abs(filtroNumeroMonetario - valorNumeroMonetario) < 0.000001;

            processo.setMostrar(processo.mostrar && (achouPorTexto || achouPorNumero || achouPorValorMonetario));
        }
    }

    private normalizarNumeroMonetario(valor: string): number | undefined {
        if (!valor) {
            return undefined;
        }

        let texto = valor.trim();
        if (!texto) {
            return undefined;
        }

        texto = texto.replace(/\s+/g, '').replace(/[^\d,.-]/g, '');

        const ultimoIndiceVirgula = texto.lastIndexOf(',');
        const ultimoIndicePonto = texto.lastIndexOf('.');

        if (ultimoIndiceVirgula >= 0 && ultimoIndicePonto >= 0) {
            if (ultimoIndiceVirgula > ultimoIndicePonto) {
                texto = texto.replace(/\./g, '').replace(',', '.');
            } else {
                texto = texto.replace(/,/g, '');
            }
        } else if (ultimoIndiceVirgula >= 0) {
            texto = texto.replace(',', '.');
        }

        const numero = Number(texto);
        return Number.isFinite(numero) ? numero : undefined;
    }
    filtrarPorResponsavelPelaTriagemFilter = (processo: Processo) => {
        if (this.camposDeResponsavelPelaTriagemFilter?.length > 0) {
            processo.setMostrar(processo.mostrar && (this.camposDeResponsavelPelaTriagemFilter.find(usuario => usuario.login === processo.triagem?.cpfResponsavel) != undefined));
        }
    }

    /**
     * Aplica um predicado a cada minuta do processo (ou ao próprio processo, se não houver
     * minutas nenhuma). Usado pelos filtros cujo predicado é o mesmo nos dois casos.
     */
    private filtrarPorMinutaOuProcesso(processo: Processo, predicado: () => boolean): void {
        if (processo.minutas.length > 0) {
            processo.minutas.forEach(minuta => {
                minuta.setMostrar(minuta.mostrar && predicado());
            });
        } else {
            processo.setMostrar(processo.mostrar && predicado());
        }
    }

    /**
     * Aplica um predicado por minuta; se o processo não tiver minuta nenhuma, ele é ocultado
     * (não há minuta para satisfazer um filtro que depende de dados da minuta).
     */
    private filtrarPorMinuta(processo: Processo, predicado: (minuta: Minuta) => boolean): void {
        if (processo.minutas.length > 0) {
            processo.minutas.forEach(minuta => {
                minuta.setMostrar(minuta.mostrar && predicado(minuta));
            });
        } else {
            processo.setMostrar(false);
        }
    }

    filtrarResponsavel = (processo: Processo) => {
        if (this.possuiResponsavel) {
            this.filtrarPorMinutaOuProcesso(processo, () => !!(processo.numeroCpfResponsavel && processo.numeroCpfResponsavel.length > 0));
        } else if (this.naoPossuiResponsavel) {
            this.filtrarPorMinutaOuProcesso(processo, () => !processo.numeroCpfResponsavel);
        }
    }

    filtrarRedatorDesignado = (processo: Processo) => {
        if (this.possuiRedatorDesignado) {
            processo.setMostrar(processo.mostrar && processo.relator != null);
        }
    }

    filtrarRetornoGabinete = (processo: Processo) => {
        if (this.processoRetornandoAoGabinete) {
            processo.setMostrar(processo.mostrar && processo.retorno == true);
        }
    }

    filtrarPorProcessosForaDoGabinete = (processo: Processo) => {
        if (!this.incluirForaDoGabineteFilter || ((RouterStore.isEscaninhoAssinatura || RouterStore.isEscaninhoPeticao) && this.foraDoGabineteFilter)) {
            if (this.foraDoGabineteFilter) {
                processo.setMostrar(processo.mostrar && !processo?.noFluxoCerto);
            } else {
                processo.setMostrar(processo.mostrar && processo?.noFluxoCerto);
            }
        }
    }

    filtrarPorOrigem = (processo: Processo) => {
        const origemSelecionada = String(this.origem || '').toUpperCase();
        const filtraLegado = origemSelecionada.includes('L');
        const filtraPje = origemSelecionada.includes('P');

        if (!filtraLegado && !filtraPje) {
            return;
        }

        if (filtraLegado && filtraPje) {
            return;
        }

        processo.setMostrar(processo.mostrar && ((filtraLegado && processo.ehLegado)
            || (filtraPje && processo.ehPje)));
    }

    filtrarPorTipoMinuta = (processo: Processo) => {
        if (this.possuiMinutaDespacho || this.possuiMinutaDecisao || this.possuiMinutaVoto || this.possuiMinutaVotoAgravoProvido) {
            if (processo.minutas.length > 0) {
                processo.minutas.forEach(minuta => {
                    const possuiDespacho = this.possuiMinutaDespacho && minuta.isTipo(TipoMinuta.DESPACHO);
                    const possuiDecisao = this.possuiMinutaDecisao && minuta.isTipo(TipoMinuta.DECISAO);
                    const possuiVoto = this.possuiMinutaVoto && minuta.isTipo(TipoMinuta.VOTO);
                    const possuiVotoAgravoProvido = this.possuiMinutaVotoAgravoProvido && minuta.isTipo(TipoMinuta.VOTO_FASE_FUTURA)
                    minuta.setMostrar(minuta.mostrar && (possuiDespacho || possuiDecisao || possuiVoto || possuiVotoAgravoProvido));
                });
            } else {
                processo.setMostrar(false);
            }
        } else if (this.naoPossuiMinuta) {
            if (processo.minutas.length > 0) {
                processo.minutas.forEach(minuta => {
                    minuta.setMostrar(minuta.mostrar && false);
                });
            } else {
                processo.setMostrar(processo.mostrar && true);
            }
        }
    }

    filtrarPorJulgado = (processo: Processo) => {
        //TODO conferir de onde pegar o resultado de julgamento do processo ...fetch.. processopai? minuta? conferir tarefadoPJe com fetch?
        if (this.julgadoFilter) {
            if (processo.minutas.length > 0) {
                processo.minutas.forEach((minuta: Minuta) => {
                    if (!minuta.isTipo(TipoMinuta.VOTO)) {
                        minuta.setMostrar(false);
                    } else {
                        if (minuta.mostrar && processo.resultadoJulgamentoProcesso && processo.resultadoJulgamentoProcesso.tipoSituacaoPautaDto
                            && processo.resultadoJulgamentoProcesso.tipoSituacaoPautaDto.codigoTipoSituacaoPauta === 'JG') {
                            let tarefaFluxoPje;
                            InformacoesProcessoService.consultarTarefaFluxoPJe(processo.identificadorProcesso).then(result => {
                                tarefaFluxoPje = result;
                                minuta.setMostrar(minuta.mostrar && tarefaFluxoPje && tarefaFluxoPje.tarefaAtual === 'Assinar acórdão')
                            }).catch(error => {
                                MensagemStore.apresentarErro('Não foi possível recuperar a tarefa do fluxo PJe. Por favor tente novamente.');
                                console.error(error);
                            });
                        } else {
                            minuta.setMostrar(false);
                        }
                    }
                });
            } else {
                if (processo.mostrar && processo.resultadoJulgamentoProcesso && processo.resultadoJulgamentoProcesso.tipoSituacaoPautaDto
                    && processo.resultadoJulgamentoProcesso.tipoSituacaoPautaDto.codigoTipoSituacaoPauta === 'JG') {
                    InformacoesProcessoService.consultarTarefaFluxoPJe(processo.identificadorProcesso).then(result => {
                        const tarefaFluxoPje = result;
                        processo.setMostrar(processo.mostrar && tarefaFluxoPje && tarefaFluxoPje.tarefaAtual === 'Assinar acórdão')
                    }).catch(error => {
                        MensagemStore.apresentarErro('Não foi possível recuperar a tarefa do fluxo PJe. Por favor tente novamente.');
                        console.error(error);
                    });
                } else {
                    processo.setMostrar(false);
                }
            }
        } else if (this.naoJulgadoFilter) {
            if (processo.minutas.length > 0) {
                processo.minutas.forEach(minuta => {
                    if (minuta.isTipo(TipoMinuta.VOTO)) {
                        if (minuta.mostrar && processo.resultadoJulgamentoProcesso?.tipoSituacaoPautaDto?.codigoTipoSituacaoPauta === 'JG') {
                            InformacoesProcessoService.consultarTarefaFluxoPJe(processo.identificadorProcesso).then(result => {
                                const tarefaFluxoPje = result;
                                minuta.setMostrar(minuta.mostrar && tarefaFluxoPje && tarefaFluxoPje.tarefaAtual !== 'Assinar acórdão')
                            }).catch(error => {
                                MensagemStore.apresentarErro('Não foi possível recuperar a tarefa do fluxo PJe. Por favor tente novamente.');
                                console.error(error);
                            });
                        }// else {//    minuta.setMostrar(minuta.mostrar && true);// }
                    }
                });
            } else {
                if (processo.mostrar && processo.resultadoJulgamentoProcesso?.tipoSituacaoPautaDto
                    && processo.resultadoJulgamentoProcesso.tipoSituacaoPautaDto.codigoTipoSituacaoPauta === 'JG') {
                    InformacoesProcessoService.consultarTarefaFluxoPJe(processo.identificadorProcesso).then(result => {
                        const tarefaFluxoPje = result;
                        processo.setMostrar(processo.mostrar && tarefaFluxoPje && tarefaFluxoPje.tarefaAtual !== 'Assinar acórdão')
                    }).catch(error => {
                        MensagemStore.apresentarErro('Não foi possível recuperar a tarefa do fluxo PJe. Por favor tente novamente.');
                        console.error(error);
                    });
                } // else {//    processo.setMostrar(processo.mostrar && true);// }
            }
        }
    }

    filtrarPorTipoJulgamento = (processo: Processo) => {
        if (this.tipoJulgamentoPresencialFilter || this.tipoJulgamentoVirtualFilter) {
            if (this.tipoJulgamentoPresencialFilter && (processo as Processo)?.tipoJulgamento?.tipoJulgamento === 'VIRTUAL') {
                processo.setMostrar(false);
            } else if (this.tipoJulgamentoVirtualFilter && !((processo as Processo)?.tipoJulgamento?.tipoJulgamento === 'VIRTUAL')) {
                processo.setMostrar(false);
            }
        }
    }

    filtrarPorPeticaoPendente = async (processo: Processo) => {
        if (this.possuiPeticaoPendente || this.naoPossuiPeticaoPendente || RouterStore.isEscaninhoPeticao) {
            const carregandoPeticoes = ProcessoStore.carregandoPeticoesPendentes
                // || ProcessoStore.carregandoQTDPeticoesPendentes
                // || ProcessoStore.carregandoDocPeticoes
                || ProcessoExpandidoStore.carregandoPecas;
            if (carregandoPeticoes) {
                return;
            }
            const peticoesPendentesVisiveis = processo.peticoesPendentesVisiveis ?? [];
            const possuiPeticaoPendente = peticoesPendentesVisiveis.length > 0;
            if (this.naoPossuiPeticaoPendente) {
                processo.setMostrar(processo.mostrar && !possuiPeticaoPendente);
            } else if (processo.mostrar && possuiPeticaoPendente) {
                if (this.tipoPeticaoSelecionadaFilter.length > 0 && this.tipoPeticaoSelecionadaFilter[0] !== 'Qualquer tipo') {
                    const tiposSelecionados = this.tipoPeticaoSelecionadaFilter
                        .filter(tipo => !!tipo && tipo !== 'Qualquer tipo')
                        .map(tipo => tipo.toString().trim().toLowerCase());

                    processo.setMostrar(processo.mostrar
                        && (FiltroService.compararCampoDeObjeto(this.tipoPeticaoSelecionadaFilter, processo, 'pecasPeticoesPendentes', 'assuntoPeticao')
                            || processo.pecasPeticoesPendentes?.find(pp => {
                                const tipoPeca = pp?.tipo?.nomeTipoProcessoDocumento?.toString().trim().toLowerCase();
                                return !!tipoPeca && tiposSelecionados.includes(tipoPeca);
                            }) != undefined
                            || peticoesPendentesVisiveis?.find(pp => {
                                const tipoPeticao = pp?.tipo?.toString().trim().toLowerCase();
                                const tituloPeticao = pp?.titulo?.toString().trim().toLowerCase();
                                return tiposSelecionados.some(tipoSelecionado =>
                                    (tipoPeticao && tipoPeticao === tipoSelecionado)
                                    || (tituloPeticao && tituloPeticao.includes(tipoSelecionado))
                                );
                            }) != undefined)
                    );
                }

                if (processo.mostrar && this.possuiIntervaloDataPeticao) {
                    const possuiPeticaoNoIntervalo =
                        this.filtrarPeticoesPendentesPorData(peticoesPendentesVisiveis).length > 0;

                    processo.setMostrar(processo.mostrar && possuiPeticaoNoIntervalo);
                }
            } else {
                processo.setMostrar(false);
            }
        }
    }

    filtrarPorImpedimento = (processo: Processo) => {
        if (this.possuiImpedimento) {
            if (processo.impedimentos?.length > 0) {
                if (this.motivoImpedimentoSelecionadoFilter.length > 0 && this.motivoImpedimentoSelecionadoFilter[0] !== 'Qualquer tipo') {
                    processo.setMostrar(processo.mostrar && (processo.impedimentos?.find(impedimento => {
                        return impedimento.includes(this.motivoImpedimentoSelecionadoFilter.join(' '))
                    }) !== undefined));
                } else {
                    processo.setMostrar(processo.mostrar && processo.impedimentos?.length > 0);
                }
            } else {
                processo.setMostrar(false);
            }
        }
    }

    filtrarPorControleGabinete = (processo: Processo) => {
        if (this.tarefaSelecionadaFilter.length > 0) {
            this.filtrarPorMinutaOuProcesso(processo, () =>
                FiltroService.compararCampoDeObjeto(this.tarefaSelecionadaFilter, processo, undefined, 'controleGabinete', 'descricao'));
        }
    }

    filtrarPorUsuario = (processo: Processo) => { //TODO
        if (this.usuarioSelecionadoFilter.length > 0) {
            this.filtrarPorMinutaOuProcesso(processo, () =>
                FiltroService.compararCampoDeObjeto(this.usuarioSelecionadoFilter, processo, undefined, 'numeroCpfResponsavel', undefined));
        }
    }

    filtrarPorRelator = (processo: Processo) => {
        if (this.relatorProcessoFilter.length > 0) {
            processo.setMostrar(processo.mostrar && FiltroService.compararCampoDeObjeto(this.relatorProcessoFilter, processo, undefined, 'orgaoJulgador', 'sigla'))
        }
    }

    filtrarPorOrgaoJulgador = (processo: Processo) => {
        if (this.orgaoJudicanteSelecionadoFilter.length > 0) {
            processo.setMostrar(processo.mostrar && FiltroService.compararCampoDeObjeto(this.orgaoJudicanteSelecionadoFilter, processo, undefined, 'orgaoJulgadorColegiado', 'sigla'));
        }
    }

    filtrarPorAndTramTarefas = (processo: Processo) => {
        const filtros = this.andTramTarefasSelecionadoFilter;

        if (!filtros || filtros.length === 0) return;

        const tarefaFluxo = processo.tarefaFluxoPje?.tarefaAtual;
        const tarefaPauta = processo.situacaoDeInclusaoEmPauta;
        const movimentoCNJ = processo.ultimoMovimentoCNJ;

        const achou =
            filtros.some(filtro =>
                (tarefaFluxo && tarefaFluxo.toUpperCase() === filtro.toUpperCase()) ||
                (tarefaPauta && tarefaPauta.toUpperCase() === filtro.toUpperCase()) ||
                (movimentoCNJ && movimentoCNJ.toUpperCase() === filtro.toUpperCase())
            );

        processo.setMostrar(achou);
    };

    filtrarPorEtiqueta = (processo: Processo) => { //TODO
        if (this.etiquetaSelecionadaFilter.length > 0) {
            const nenhum = new TAG_NENHUMA_ETIQUETA();
            const alguma = new TAG_ALGUMA_ETIQUETA();
            const nenhumaSelecionado = this.etiquetaSelecionadaFilter.some(etiqueta => etiqueta.numero ? (etiqueta.numero === nenhum.numero) : (etiqueta.texto === nenhum.texto));
            const algumaSelecionado = this.etiquetaSelecionadaFilter.some(etiqueta => etiqueta.numero ? (etiqueta.numero === alguma.numero) : (etiqueta.texto === nenhum.texto));

            if (nenhumaSelecionado) {
                processo.setMostrar(processo.mostrar && processo.etiquetas.length === 0);
            } else if (algumaSelecionado) {
                processo.setMostrar(processo.mostrar && processo.etiquetas.length > 0);
            } else {
                processo.setMostrar(processo.mostrar && FiltroService.compararCampoDeObjeto(this.etiquetaSelecionadaFilter.map(e => e.texto), processo, 'etiquetas', 'texto'));
            }

        }
    }

    filtrarPorIndicador = (processo: Processo) => {
        if (this.indicadorSelecionadoFilter.length > 0) {
            const semIndicadoresSelecionado = this.indicadorSelecionadoFilter.includes('#null#');
            if (semIndicadoresSelecionado) {
                processo.setMostrar(processo.mostrar && (!processo.indicadores || processo.indicadores.length === 0));
                return;
            }

            processo.setMostrar(processo.mostrar && FiltroService.compararCampoDeObjeto(this.indicadorSelecionadoFilter, processo, 'indicadores', 'descricao'));
        }
    }

    filtrarPorAssunto = (processo: Processo) => {
        if (this.assuntoFilter.length > 0) {
            this.assuntoFilter.forEach(assunto => {
                processo.setMostrar(processo.mostrar && FiltroService.compararCampoDeObjeto([assunto.split(' - ')[0]], processo, 'assuntosProcesso', 'codigoAssunto'));

            })
        }
    }

    private normalizarString(texto: string): string {
        return texto?.trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") || '';
    }

    private formatarValorCondenacaoChip(valor: string): string {
        const texto = valor?.trim() || '';
        if (!texto) return '';

        const valorSomenteNumerico = texto.replace(/[^\d,.-]/g, '');
        let numero = Number.NaN;

        if (valorSomenteNumerico.includes(',')) {
            const normalizado = valorSomenteNumerico.replace(/\./g, '').replace(',', '.');
            numero = Number(normalizado);
        } else {
            numero = Number(valorSomenteNumerico);
        }

        if (Number.isNaN(numero)) {
            return texto;
        }

        return numero.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }

    private filtrarPorTexto(obj: Map<string, string>, termoBusca): string[] {
        if (!obj) {
            // partesProcessos ainda não terminou de carregar (busca assíncrona em
            // buscarPartesProcessoFiltro) - sem dados pra filtrar ainda.
            return [];
        }
        const palavrasBusca = this.normalizarString(termoBusca).split(/\s+/).filter(Boolean);

        const resultado = Object.entries(obj)
            .map(([id, partes]) => [id, this.normalizarString(partes)])
            .filter(([_id, partes]) => {
                return palavrasBusca.every(palavra =>
                    partes.includes(palavra)
                )
            })
            .map(([id]) => id);
        return resultado;
    }

    filtrarPorNomeParte = async (processo: Processo) => {
        if (this.parteFilter) {
            const idsProcessos = this.filtrarPorTexto(this.partesProcessos, this.parteFilter)
            processo.setMostrar(processo.mostrar && idsProcessos.toString().includes(processo.identificadorProcesso.toString()));
        }
    }

    findParte(existeParte, partes, nome) {
        return partes && partes.find(parte => {
            existeParte = parte.nome === nome;
            existeParte = existeParte || this.findRepresentante(parte.representantes, existeParte, nome);
            return existeParte
        });
    }

    findRepresentante(array: any[], existeParte, nome) {
        if (array) {
            existeParte = array.find(representante => {
                return representante.nome === nome;
            });
        }
        return existeParte;
    }

    filtrarPorClasse = (processo: Processo) => {
        if (this.classeProcessoFilter.length > 0) {
            const achouClasse = this.classeProcessoFilter.find(ca => ca == processo.classe.split('-')[0].trim());
            processo.setMostrar(processo.mostrar && !!achouClasse);
        }
    }

    filtrarPorClasseInteira = (processo: Processo) => {
        if (this.classeInteiraFilter.length > 0) {
            const achouClasse = this.classeInteiraFilter.find(ca => ca === processo.classe.trim());
            processo.setMostrar(processo.mostrar && !!achouClasse);
        }
    }

    filtrarPorClasseInicial = (processo: Processo) => {
        if (this.classeInicialProcessoFilter?.length > 0) {
            const achouClasseInicial = this.classeInicialProcessoFilter.find(ca => {
                const classes = processo.classe.split('-');
                return ca == classes[classes.length - 1].trim();
                //return ca == processo.classe.split('-')[0].trim()
            });
            processo.setMostrar(processo.mostrar && !!achouClasseInicial);
        }
    }



    filtrarPorCategoria = (processo: Processo) => {
        if (this.categoriaProcessoFilter.length > 0) {
            if (processo.minutas.length > 0) {
                this.categoriaProcessoFilter.forEach((categoria: CategoriaMinuta) => {
                    processo.minutas.forEach((minuta) => {
                        const achouCategoria = minuta.categorias?.some((catMinuta) => {
                            return catMinuta.numero === categoria.numero;
                        });
                        minuta.setMostrar(minuta.mostrar && achouCategoria);
                    });
                });
            } else {
                processo.setMostrar(false);
            }
        }
    }

    filtrarPorPauta = (processo: Processo) => {
        if (this.pautaFilter.length > 0) {
            processo.setMostrar(processo.mostrar && FiltroService.compararCampoDeObjeto(this.pautaFilter, processo, undefined, 'pauta', 'idPauta'));
        }
    }

    filtrarPorMovimentacao = (processo: Processo) => {
        if (this.movimentosFilter && this.movimentosFilter.length > 0) {
            const semMovimentacaoSelecionado = this.movimentosFilter.includes('#null#');
            if (semMovimentacaoSelecionado) {
                const semMovimento = (processo.minutas || []).every(minuta => (minuta.movimentosCNJ || []).length === 0);
                processo.setMostrar(processo.mostrar && semMovimento);
                return true;
            }

            let mostrar = false;
            processo.minutas.forEach(minuta => {
                minuta.movimentosCNJ.forEach(mov => {
                    this.movimentosFilter.forEach(movFilter => {
                        const codigoMovimento = mov.codMovimentoCnj?.toString();
                        if (codigoMovimento == movFilter) {
                            mostrar = true;
                        }
                    });
                });
            });
            processo.setMostrar(processo.mostrar && mostrar);
        }

        return true;

    }

    filtrarPorAssinavelETipoDeMinuta = (processo: Processo) => {
        if (!this.assinavel) return;

        if (!processo.minutas || processo.minutas.length === 0) {
            processo.setMostrar(false);
            return;
        }

        const ehSecretaria = UsuarioStore.ehSecretario || UsuarioStore.ehLocalizacaoSecretaria;

        processo.minutas.forEach(minuta => {
            const tipoIgual = this.tipoMinutaFilter?.includes(minuta.tipo.descricao) ?? false;
            const codigoSituacao = minuta.situacaoMinuta.codigo;
            const codigoTipo = minuta.tipo.codigo;
            const situacaoValida = codigoSituacao >= 30 && codigoSituacao < 40;

            const assinavel = minuta.minutaParaAssinarDto?.assinavel ?? minuta.assinavel;
            const ehDespachoOuDecisao = codigoTipo === TipoMinuta.DESPACHO || codigoTipo === TipoMinuta.DECISAO;

            const ignorarAssinavel =
                codigoTipo === TipoMinuta.VOTO_VENCIDO ||
                ((assinavel === undefined || assinavel === null) &&
                    codigoSituacao === 30 &&
                    ehDespachoOuDecisao) ||
                (ehSecretaria && ehDespachoOuDecisao && situacaoValida);

            const mostrar =
                situacaoValida &&
                (this.tipoMinutaFilter?.length > 0 ? tipoIgual : true) &&
                (ignorarAssinavel ? true : assinavel === true);

            minuta.setMostrar(!!mostrar);
        });

        const algumaMostra = processo.minutas.some(m => !!m.mostrar);
        processo.setMostrar(algumaMostra);
    };

    filtrarPorPublicavel = (processo: Processo) => {
        if (this.publicavelFilter) {
            this.filtrarPorMinuta(processo, minuta => minuta.publicavel || minuta.tipo.codigo == 3);
        }
    }

    filtrarPorNaoPublicavel = (processo: Processo) => {
        if (this.naoPublicavelFilter) {
            this.filtrarPorMinuta(processo, minuta => !minuta.publicavel && minuta.tipo.codigo != 3);
        }
    }

    filtrarPorVotoLiberado = (processo: Processo) => {
        if (this.votoLiberadoFilter) {
            this.filtrarPorMinuta(processo, minuta => minuta.votoJaliberado && minuta.tipo.codigo == 3);
        }
    }

    filtrarPorVotoNaoLiberado = (processo: Processo) => {
        if (this.votoNaoLiberadoFilter) {
            this.filtrarPorMinuta(processo, minuta => !minuta.votoJaliberado && minuta.tipo.codigo == 3);
        }
    }

    filtrarComCorreJunto = (processo: Processo) => {
        if (!this.correJuntoFilter) return;
        processo.setMostrar((processo.correJuntos?.length ?? 0) > 0);
    }

    filtrarComAssociado = (processo: Processo) => {
        if (!this.associadoFilter) return;
        processo.setMostrar((processo.processosAssociados?.length ?? 0) > 0);
    }


    filtrarFavorito = (processo: Processo) => {
        if (this.favoritoFilter) {
            processo.setMostrar(processo.mostrar && processo.favorito);
        }
    }

    filtrarNaoFavorito = (processo: Processo) => {
        if (this.naoFavoritoFilter) {
            processo.setMostrar(processo.mostrar && !processo.favorito);
        }
    }

    filtrarPorSituacaoDePeticao = (processo: Processo) => {
        if (this.situacaoPeticaoFilter) {
            processo.setMostrar(processo.mostrar && (processo.peticoesPendentes.find(pet => pet.situacaoPeticao === this.situacaoPeticaoFilter) !== undefined));
        }
    }

    filtrarPorSituacao = (processo: Processo) => {
        if (this.situacaoMinutaFilter?.length > 0) {
            this.filtrarPorMinuta(processo, minuta =>
                FiltroService.compararCampoDeObjeto(this.situacaoMinutaFilter, minuta, undefined, 'situacaoMinuta', 'descricao'));
        }
    }

    filtrarPorRevisorPauta = (processo: Processo) => {
        if (this.revisorPautaFilter?.length > 0) {
            PautaRevisaoStore.hidratar();
            PautaRevisaoStore.sincronizarComProcesso(processo);
            const revisoresSelecionados = this.revisorPautaFilter
                .map(revisor => String(revisor || '').trim())
                .filter(Boolean);

            const filtrarSemRevisor = revisoresSelecionados.includes(FILTRO_SEM_REVISOR);
            const revisoresSelecionadosComCpf = revisoresSelecionados.filter(revisor => revisor !== FILTRO_SEM_REVISOR);

            const revisoresProcesso = [
                PautaRevisaoStore.getRevisor(processo.identificadorProcesso),
                ...processo.minutas
                    .filter(minuta => minuta && this.minutaValidaPauta(minuta))
                    .map(minuta => minuta.cpfRevisorPauta)
            ]
                .filter(Boolean)
                .map(revisor => String(revisor).trim())
                .filter(Boolean);

            const possuiRevisor = revisoresProcesso.length > 0;
            const matchComRevisorSelecionado = revisoresSelecionadosComCpf.length > 0
                && revisoresProcesso.some(revisor => revisoresSelecionadosComCpf.includes(revisor));
            const matchSemRevisor = filtrarSemRevisor && !possuiRevisor;

            processo.setMostrar(processo.mostrar && (matchComRevisorSelecionado || matchSemRevisor));
        }
    }

    filtrarPorStatusRevisao = (processo: Processo) => {
        if (this.statusRevisaoFilter?.length > 0) {
            PautaRevisaoStore.hidratar();
            PautaRevisaoStore.sincronizarComProcesso(processo);
            const minutasValidas = processo.minutas
                .filter(m => m && m.numero && this.minutaValidaPauta(m))
            const numerosMinutas = minutasValidas.map(m => m.numero);
            const codigos = PautaRevisaoStore.statusRevisaoDoProcesso(processo.identificadorProcesso, numerosMinutas);
            minutasValidas.forEach(minuta => {
                const codigo = (minuta.statusRevisao as any)?.numero ?? (minuta.statusRevisao as any)?.codigo;
                if (codigo !== undefined && codigo !== null) {
                    codigos.push(Number(codigo));
                }
            });
            const selecionados = this.statusRevisaoFilter.map(Number);
            processo.setMostrar(processo.mostrar && codigos.some(codigo => selecionados.includes(Number(codigo))));
        }
    }

    private minutaValidaPauta(minuta: Minuta): boolean {
        if (minuta.situacaoMinuta?.codigo === SituacaoMinuta.EM_ELABORACAO) {
            return false;
        }

        const descricaoTipo = (minuta.tipo?.descricao || '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .trim()
            .toLowerCase();
        const ehVoto = minuta.tipo?.codigo === TipoMinuta.VOTO ||
            minuta.tipo?.codigo === TipoMinuta.VOTO_AGUIA ||
            descricaoTipo.startsWith('voto');

        return !(ehVoto &&
            minuta.situacaoMinuta?.codigo === SituacaoMinuta.LIBERADA_PARA_ASSINATURA_OU_INCLUSAO_EM_PAUTA &&
            !minuta.vistoLiberado);
    }

    filtrarPorCpfsUltimaAlteracaoSituacaoMinuta = (processo: Processo) => {
        if (this.usuariosUltimaAlteracaoSituacaoMinutaFilter?.length > 0) {
            if (this.historicoMinuta.length === 0) {
                return
            }
            this.filtrarPorMinuta(processo, minuta => {
                const ultimoModificador = this.historicoMinuta.find(element => element.numeroMinuta === minuta.numero);
                return this.usuariosUltimaAlteracaoSituacaoMinutaFilter.some(usuario => usuario.login === ultimoModificador?.cpfResponsavel);
            });
        }
    }

    filtrarPorUnidadePublicadora = (processo: Processo) => {
        if (this.unidadePublicadoraFilter?.length > 0) {
            this.filtrarPorMinuta(processo, minuta => {
                const unidade = this.unidadesDePublicacao.find(unidade => unidade.codigo === minuta.codUnAdmPub);
                return minuta.codUnAdmPub ?
                    this.unidadePublicadoraFilter.includes(unidade?.nome)
                    :
                    this.unidadePublicadoraFilter.includes('Sem unidade');
            });
        }
    }

    filtrarPorResultadoJulgamento = (processo: Processo) => {

        if (this.resultadoJulgamentoFilter.length === 0) {
            return;
        }

        const tipoAtual = processo.resultadoJulgamentoProcesso?.tipoSituacaoPautaDto?.tipoSituacaoPauta;
        const filtros = this.resultadoJulgamentoFilter.map(f => f.toUpperCase());

        if (tipoAtual) {
            const achou = filtros.includes(tipoAtual.toUpperCase());

            processo.setMostrar(achou);
            return;
        }

        processo.setMostrar(false);
    }

    formataNomeFiltro(descricao: string) {
        switch (descricao) {
            case 'foraDoFluxo':
                return 'Fora do Fluxo';

            case 'assinatura':
                return 'Assinatura';

            case 'origem':
                return 'Origem (ESIJ / PJe)';

            case 'numeroProcesso':
                return 'Número do Processo';

            case 'listaProcesso':
                return 'Lista de Processos';

            case 'ojc':
                return 'OJC (Órgão Julgador Colegiado)';

            case 'andamento':
                return 'Andamentos processual';

            case 'movimentacao':
                return 'Movimentação Interna';

            case 'anoAutuacao':
                return 'Ano de Autuação';

            case 'etiqueta':
                return 'Etiquetas';

            case 'responsavel':
                return 'Responsável';

            case 'relator':
                return 'Relator do Processo';

            case 'possuiResponsavel':
                return 'Possui Responsável';

            case 'indicador':
                return 'Indicadores / Chips';

            case 'classe':
                return 'Classe';

            case 'assunto':
                return 'Assuntos';

            case 'categoria':
                return 'Categoria';

            case 'inclusaoPauta':
                return 'Última Inclusão em Pauta';

            case 'movimento':
                return 'Movimentos/Códigos de Decisão';

            case 'partes':
                return 'Partes';

            case 'resultadoJulgamento':
                return 'Resultado de Julgamento';

            case 'situacaoMinuta':
                return 'Situação da Minuta';

            case 'peticao':
                return 'Possui / Não possui petição pendente';

            case 'impedimento':
                return 'Possui Impedimento/Suspeição';

            case 'tipoJulgamento':
                return 'Tipo de Julgamento (Presencial / Virtual)';

            case 'possuiMinuta':
                return 'Possui Minuta';

            case 'unidadePublicadora':
                return 'Unidade Publicadora';

            case 'publicavel':
                return 'Publicável';

            case 'estrela':
                return 'Estrela / Processos Favoritos';

            case 'redator':
                return 'Redator Designado';

            case 'retornoGabinete':
                return 'Retorno (Processo retornando ao gabinete)';

            case 'triagemLivre':
                return 'Triagem Livre';

            case 'tiposPeticoesPendentes':
                return 'Tipos de Petições Pendentes';

            case 'votoLiberado':
                return 'Liberação de Voto'

            case 'correJuntoAssociado':
                return 'Corre Junto ou Associado'

            default:
                return 'Filtro não encontrado';
        }
    }

    filtros = [
        this.filtrarPorOrigem,
        this.filtrarNumeroProcesso,
        this.filtrarPorListaDeNumeroProcesso,
        this.filtrarPorControleGabinete,
        this.filtrarPorAnoAutuacao,
        this.filtrarResponsavel,
        this.filtrarRedatorDesignado,
        this.filtrarRetornoGabinete,
        this.filtrarPorTipoMinuta,
        this.filtrarPorJulgado,
        this.filtrarPorTipoJulgamento,
        this.filtrarPorPeticaoPendente,
        this.filtrarPorImpedimento,
        this.filtrarPorUsuario,
        this.filtrarPorNomeParte,
        this.filtrarPorAssunto,
        this.filtrarPorOrgaoJulgador,
        this.filtrarPorAndTramTarefas,
        this.filtrarPorEtiqueta,
        this.filtrarPorIndicador,
        this.filtrarPorClasse,
        this.filtrarPorClasseInteira,
        this.filtrarPorClasseInicial,
        this.filtrarPorCategoria,
        this.filtrarPorPauta,
        this.filtrarPorMovimentacao,
        this.filtrarPorProcessosForaDoGabinete,
        this.filtrarPorSituacao,
        this.filtrarPorRevisorPauta,
        this.filtrarPorStatusRevisao,
        this.filtrarPorUnidadePublicadora,
        this.filtrarPorResultadoJulgamento,
        this.filtrarPorCpfsUltimaAlteracaoSituacaoMinuta,
        this.filtrarPorPublicavel,
        this.filtrarPorNaoPublicavel,
        this.filtrarPorTriagem,
        this.filtrarFavorito,
        this.filtrarNaoFavorito,
        this.filtrarPorSituacaoDePeticao,
        this.filtrarPorTema,
        this.filtrarPorCampoDeTriagemBoolean,
        this.filtrarPorCampoDeTriagemValorCondenacao,
        this.filtrarPorResponsavelPelaTriagemFilter,
        this.filtrarPorVotoLiberado,
        this.filtrarPorVotoNaoLiberado,
        this.filtrarPorRelator,
        this.filtrarComCorreJunto,
        this.filtrarComAssociado
    ];

}

export default new FiltroStore();
